import { Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AuthGate } from "./components/AuthGate";
import { AdminShell } from "./layouts/AdminShell";
import { DashboardPage } from "./pages/DashboardPage";
import { RoomsPage } from "./pages/RoomsPage";
import { RoomDetailPage } from "./pages/RoomDetailPage";
import { AdminPreviewPage } from "./pages/AdminPreviewPage";
import { PublicPrivacyPage, VisitorPrivacyPage } from "./pages/PrivacyPage";
import { ViewerPage } from "./pages/ViewerPage";
import { StandalonePreviewPage } from "./pages/StandalonePreviewPage";
import { LoginPage } from "./pages/LoginPage";
import { NotificationSettingsPage } from "./pages/NotificationSettingsPage";

export function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/v/:token" element={<ViewerPage />} />
        <Route path="/v/:token/doc/:documentId" element={<StandalonePreviewPage />} />
        <Route path="/v/:token/privacy" element={<VisitorPrivacyPage />} />
        <Route path="/privacy" element={<PublicPrivacyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <AuthGate>
              <AdminShell />
            </AuthGate>
          }
        >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/rooms/:roomId" element={<RoomDetailPage />} />
          <Route path="/rooms/:roomId/preview/:documentId" element={<AdminPreviewPage />} />
          <Route path="/alerts" element={<NotificationSettingsPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
